 <template>
  <v-container fluid class="px-0">
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1" style="display: flex;">{{ $t('Mano dokumentai') }}<el-tooltip tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Mano dokumentai. Mano dokumentai" mainTitle></el-tooltip></h1>
    <!-- search -->
    <documents-search :loading="loading" @search="searchRecords" />
    <!-- info -->
    <span>{{ getInfoText }}</span>
    <!-- table -->
    <v-data-table
      class="mb-4 custom-table sticky-header-sav"
      :loading="loading || paginationloading"
      :headers="filteredHeader"
      :items="filterItemList"
      :hide-default-footer="hideFooter"
      :header-props="{
        sortByText: $t('Rūšiuoti pagal')
      }"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: $t('Rodyti po:'),
        itemsPerPageAllText: $t('visi'),
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :sort-by.sync="pagination.sort"
      :sort-desc.sync="pagination.sortDesc"
      :server-items-length="pagination.total"
      :items-per-page="pagination.pageSize"
      :page.sync="pagination.page"
      @update:options="updatePagination"
    >
      <!-- custom templates -->
      <template #[`item.in_journal_type`]="{ item }">
        <el-table-enum
          enumName="inJournalType"
          :item="item.in_journal_type.toString()"
        />
      </template>
      <template #[`item.status`]="{ item }">
        <el-table-enum enumName="journalType" :item="item.status.toString()" />
        <span v-if="item.status == '815'">
          <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
                dense
                class="table-action table-action-red"
                v-bind="attrs"
                v-on="on"
                style="color:red;"
              >
                mdi-exclamation
              </v-icon>
          </template>
          <div class="tooltip-text">{{ item.ns_reject_reason }}</div>
        </v-tooltip>
        </span>
      </template>
      <template #[`item.actions`]="{ item }">
        <div class="nowrap">
          <el-table-action
            :item="setItemParam(item)"
            fakeStatus
            @fakeStatusItem="fakeStatusItem(item)"
            @editItem="editItem(item)"
            @viewItem="viewItem(item)"
            @signItem="viewItem(item)"
            @deleteItem="deleteItem(item)"
            @addToCartItem="addToCart(item)"
            @goToCartItem="goToCart(item)"
            @downloadItem="downloadItem(item)"
            @signaturesEditable="viewItem(item)"
          />
        </div>
      </template>
      <!-- basic templates -->
      <template slot="loading"> {{ $t('Kraunasi...') }} </template>
      <template slot="no-results"> {{ $t('Duomenų nėra') }} </template>
      <template slot="no-data"> {{ $t('Duomenų nėra') }} </template>
      <template #[`footer.page-text`]="props">
        {{ $t('Rodoma') }} {{ props.pageStart }}-{{ props.pageStop }} {{ $t('iš') }}
        {{ props.itemsLength }}
      </template>
    </v-data-table>
    <modal-delete
      title="Šalinti įrašą"
      text="Ar tikrai norite pašalinti įrašą?"
      v-model="showDelete"
      :loading="loading"
      :item="modalDeleteItem"
      @confirmDelete="confirmDelete"
    />
  </v-container>
</template>

<script>
import DocumentsSearch from './DocumentsSearch'
import userRole from '@/mixins/userRole'
import ModalDelete from '@/components/modals/ModalDelete'
import tableParameters from '@/mixins/tableParameters'
import math from '@/mixins/math'
import { mapGetters } from 'vuex'

export default {
  name: 'Documents',
  components: {
    DocumentsSearch,
    ModalDelete,
  },
  mixins: [userRole, tableParameters, math],
  data() {
    return {
      pageloading: true,
      loading: true,
      cartLoading: false,
      paginationloading: false,
      search: null,
      listData: [],
      searchData: {},
      confirmTime: null,
      modalDeleteItem: null,
      showDelete: false,
      itemsPerPageOptions: [10, 50, 100],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
        totalPages: 0,
        sort: '',
        sortDesc: [true],
        direction: 'asc',
      },
    }
  },
  computed: {
    ...mapGetters(['menuState']),
    headers() {
      return [
        {
          text: this.$t('Veiksmai'),
          align: 'start',
          sortable: false,
          value: 'actions',
          width: '7rem',
        },
        {
          text: this.$t('Identifikavimo kodas'),
          align: 'center',
          sortable: true,
          value: 'code',
          width: '6rem',
        },
        {
          text: this.$t('Dokumento Nr.'),
          align: 'center',
          sortable: true,
          value: 'document_no',
          width: '6rem',
        },
        {
          text: this.$t('Dokumentų tipas'),
          align: 'start',
          value: 'in_journal_type',
          width: '6rem',
        },
        {
          text: this.$t('Būsenos data'),
          align: 'start',
          value: 'status_date',
          width: '7rem',
        },
        {
          text: this.$t('Būsena'),
          align: 'start',
          value: 'status',
          width: '8rem',
        },
      ]
    },
    getInfoText(){
      return this.confirmTime ? `${this.$t('Registrui nepateikti dokumentai saugomi')} ${this.confirmTime} ${this.$t('dienų (-as).')}` : ''
      // return `${this.$t('Įgaliotojų patvirtinimo laikas (dienomis):')} ${this.confirmTime || '-'}` 
    },
    filteredHeader() {
      return this.headers.filter((item) => {
        return !item.hide
      })
    },

    filterItemList() {
      return this.listData.map((item) => {
        return item
      })
    },

    hideFooter() {
      return this.pagination.total <= 10
    },
    canPrint() {
      return this.filterItemList.length === 0
    },
  },
  created() {
    this.getConfirmTime()
    this.isMenuState()
    // this.setlistParams()
  },
  methods: {
    downloadItem(item) {
      this.loading = true
      this.$axios
        .get(`uploads/${item.project_upload_id}/download`)
        .then((res) => {
          this.openFile(res.data)
        })
        .catch((err) => {
          const errData = JSON.parse(
            Buffer.from(err.response.data).toString('utf8')
          )
          this.$root.$emit('DATA_ERROR', errData.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    openFile(file) {
      var fileLink = document.createElement('a')
      fileLink.href = file.file
      fileLink.setAttribute(
        'download',
        this.safeFileName(file.original_filename)
      )
      document.body.appendChild(fileLink)
      fileLink.click()
    },
    getConfirmTime(){
      this.$axios.get(`confirm-time`).then((res) => {
        this.confirmTime = res.data.confirm_time

      }).catch((err) => {
        this.$root.$emit('DATA_ERROR', err)
      })
    },
    isMenuState(){
      if(this.menuState == 'show_only_statements'){
        this.$router.push({
          name: 'savInfoPage',
          params: {
            type: 'showOnlyStatements',
          },
        })
      }
    },
    isAdult(){
      if(!this.userAdult){
        this.$router.push({ name: 'home' })
      }
    },
    setItemParam(item) {
      if(item.canSign){
        item.canView = false
      }

      if (item.canDownload) {
        item.showDownloadTooltip = true
      }
      return item
    },
    getData(resetPageNr = false) {
      if(this.menuState == 'show_only_statements'){
        return
      }
      if (resetPageNr) {
        this.pagination.page = 1
      }

      this.setSortParams()

      const data = {
        ...this.pagination,
        search: this.searchData,
      }

      this.$axios
        .post(`in-journals/my-list`, data)
        .then((res) => {
          this.listData = res.data.inJournals
          this.pagination = { ...this.pagination, ...res.data.pagination }
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
          this.paginationloading = false
        })
    },
    updatePagination(pagination) {
      if (this.paginationloading) {
        return
      }
      this.$store.dispatch('listParams', {
          pageSize: pagination.itemsPerPage,
          page: pagination.page,
          route: this.$route.name,
      })
      this.paginationloading = true
      this.pagination.page = pagination.page
      this.pagination.pageSize = pagination.itemsPerPage
      this.pagination.sort = pagination.sortBy[0]
      this.pagination.sortDesc = pagination.sortDesc
      this.pagination.direction = pagination.sortDesc[0] ? 'desc' : 'asc'

      if (!this.loading) {
        this.getData()
      }
    },
    searchRecords(searchData) {
      this.searchData = searchData
      this.loading = true
      this.getData(searchData.btn)
    },
    fakeStatusItem(item) {
      let url = `local/in-journals/${item.id}/fake-payment`
      this.$axios
        .post(url)
        .then((res) => {
          this.getData()
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
        })
    },
    viewItem(item) {
      switch (item.in_journal_type) {
        case '407':
        case '412':
          this.$router.push({
            name: 'savDocumentView',
            params: {
              id: item.id,
            },
          })
          break
        case '408':
          this.$router.push({
            name: 'savMandateTerminate',
            params: {
              id: item.id,
              view: 'view',
            },
          })
          break
        case '409':
          this.$router.push({
            name: 'savMandateRefuse',
            params: {
              id: item.id,
              view: 'view',
            },
          })
          break
        case '420':
        case '421':
          this.$router.push({
            name: 'savDocumentView',
            params: {
              id: item.id,
              view: 'view',
            }
          })
          break
          case '422':
            this.$router.push({
              name: 'savProcurationTerminate',
              params: {
                id: item.id,
                view: 'view',
              }
            })
            break
          case '423':
            this.$router.push({
              name: 'savProcurationRefuse',
              params: {
                id: item.id,
                view: 'view',
              }
            })
            break
        default:
          break
      }
    },
    editItem(item) {
      switch (item.in_journal_type) {
        case '407':
          this.$router.push({
            name: 'mandateSteps',
            params: {
              step: 1,
              id: item.id,
            },
          })
          break
        case '412':
          this.$router.push({
            name: 'subMandateSteps',
            params: {
              step: 1,
              id: item.id,
            },
          })
          break
        case '420':
        case '421':
          this.$router.push({
            name: 'procurationSteps',
            params: {
              step: 1,
              id: item.id,
            }
          })
          break
        default:
          break
      }
    },
    // goToCart(item){
    //   const url = `${process.env.VUE_APP_SAVITARNA_GLOBAL_URL}basketDetails.do?basketId=${item.cart_id}&returnUrl=basketList.do`
    //   window.location.href = url
    // },
    goToCart(item){
      if (this.cartLoading == false) {
        this.cartLoading = true;
        this.$axios
        .post(`in-journals/${item.id}/cartId`)
        .then((res) => {
            let cartId = res.data.cart_id
            let url = `${process.env.VUE_APP_SAVITARNA_GLOBAL_URL}basketDetails.do?basketId=${cartId}&returnUrl=basketList.do`
            window.location.href = url
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.cartLoading = false
        })
      }
    },
    addToCart(item) {
      if (this.cartLoading == false) {
        this.cartLoading = true;
        this.$axios
        .post(`in-journals/${item.id}/cartId`)
        .then((res) => {
          let cartId = res.data.cart_id
          let url = `${process.env.VUE_APP_SAVITARNA_GLOBAL_URL}basketDetails.do?basketId=${cartId}&returnUrl=basketList.do`
          window.location.href = url
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.cartLoading = false
        })
      }
    },
    deleteItem(item) {
      this.modalDeleteItem = Object.assign({}, item)
      this.showDelete = true
    },

    confirmDelete(item) {
      this.loading = true

      this.$axios
        .delete(`in-journals/${item.id}`)
        .then((res) => {
          this.$root.$emit('DATA_OK_CODE','000048')
          this.getData()
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR_CODE', '000049')
        })
        .finally(() => {
          this.loading = false
          this.showDelete = false
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.potipis {
  background: #8eb693;

  .v-card__text {
    &.active {
      background: #2c7837;
      color: #fff;
    }
  }
}
.tikrina-chip {
  max-width: 110px;
}
</style>
